import React from 'react';
//import { useParams } from 'react-router-dom';
import { useBoolean, useDebounce } from 'hooks';
import { fetcher } from 'services';
import { getErrorMessageByStatusCode, groupBy } from 'utils';
import { LkpChart } from 'components/Charts universal/Chart';
import { ChartsParamsType } from 'components/Charts universal/types';
//import { LkpChartTopFilter } from 'components/Charts/Filters';
import { HeaderFiltersType } from 'context/GlobalFiltersContext/initialState';
import qs from 'qs';
import { isNumber } from 'fp-ts/lib/number';
export interface LkpChartSDIFailuresAnalysisProps {
  headerFilters: HeaderFiltersType;
  inicio?: string;
  fim?: string;
  sistemas?: any[];
  externalData?: any;
  externalLoading?: boolean;
  disableFetch?: boolean;
}
const LkpChartSDIFailuresAnalysis: React.FC<LkpChartSDIFailuresAnalysisProps> = ({
  headerFilters,
  inicio,
  fim,
  sistemas,
  externalData,
  externalLoading,
  disableFetch,
}) => {
  const { value: isLoading, setValue: setLoading } = useBoolean();
  const isLoadingFinal = externalLoading || isLoading;
  //const { dateFrom, dateTo } = useParams<{ dateFrom: string; dateTo: string }>();
  const { value: isError, setValue: setIsError } = useBoolean();
  const [series, setSeries] = React.useState<any[]>([104, 64, 22]);
  const [labels, setLabels] = React.useState<any[]>([]);
  const [errorMessage, setErrorMessage] = React.useState<string>();
  const [paramsSystems] = React.useState<string>('');
  const [params, setParams] = React.useState<ChartsParamsType>({
    Empresa: headerFilters?.companies?.id || 0,
    Sites: headerFilters?.units?.id,
    Inicio: inicio,
    Fim: fim,
    GrupoSite: headerFilters?.unitGroups?.id || [],
    SubGrupoSite: headerFilters?.unitSubgroups?.id || [],
    Cidade: headerFilters?.cities?.id || [],
    Estado: headerFilters?.states?.id || [],
    Sistemas: sistemas || [],
  });
  const debouncedStartValue = useDebounce<string>(params.Inicio || '', 500);
  const debouncedEndValue = useDebounce<string>(params.Fim || '', 500);
  const debouncedSystemsValue = useDebounce<string>(paramsSystems || '', 500);
  React.useEffect(() => {
    setParams(prev => ({
      ...prev,
      Inicio: inicio,
      Fim: fim,
      Sistemas: sistemas,
    }));
  }, [inicio, fim, sistemas]);
  React.useEffect(() => {
    if (disableFetch && externalData) {
      const _groupSistema = groupBy<any>(externalData, d => d.sistema);
      const _series = _groupSistema.map(({ name, data: d }) => {
        const data = d.map(({ quantidade }) => (isNumber(Number(quantidade)) ? Number(quantidade) : 0));
        return { name, data };
      });
      setSeries(_series);

      const _groupPeriodo = groupBy<any>(externalData, d => d.periodo);
      setLabels(_groupPeriodo.map(period => period?.name));
      return;
    }
    if (disableFetch) return;
    async () => {
      await fetchChartData();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    debouncedStartValue,
    debouncedEndValue,
    debouncedSystemsValue,
    headerFilters?.unitGroups?.id,
    headerFilters?.unitSubgroups?.id,
    headerFilters?.companies?.id,
    headerFilters?.states?.id,
    headerFilters?.cities?.id,
    params.Sistemas,
    disableFetch,
    externalData,
  ]);
  const fetchChartData = async () => {
    setLoading(true);
    let _httpPath = '/analise-falhas-sdai';
    if (!!paramsSystems) _httpPath = `${_httpPath}?Sistemas=${paramsSystems}`;
    const result = await fetcher
      .get<any[]>(_httpPath, 'dashboard', {
        params: {
          ...params,
          GrupoSite: headerFilters?.unitGroups?.id,
          SubGrupoSite: headerFilters?.unitSubgroups?.id,
          Cidade: headerFilters?.cities?.id,
          Estado: headerFilters?.states?.id,
        },
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      })
      .catch(error => {
        const message = getErrorMessageByStatusCode(error, _httpPath);
        setErrorMessage(message);
        setIsError(true);
      });
    if (result) {
      setLabels(result.map(({ nome }) => nome || ''));
      setSeries(result.map(({ quantidade }) => (typeof quantidade === 'string' ? parseInt(quantidade) : 0)));
    }
    setLoading(false);
  };
  React.useEffect(() => {
    (async () => {
      await fetchChartData();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <LkpChart
      title="Análise falhas SDAI"
      type="donut"
      companyId={headerFilters?.companies?.id || 0}
      series={series}
      //width={830}
      error={isError}
      errorMessage={errorMessage}
      loading={isLoadingFinal}
      options={{
        labels,
        colors: ['#47E26F', '#9089FA', '#DA3490', '#E8871A', '#5144D3', '#00C0C7'],
        dataLabels: {
          formatter: function (value, { seriesIndex, w }) {
            return w?.config?.series?.[seriesIndex];
          },
        },
      }}
      // filter={<LkpChartTopFilter onChangeStartDate={handleChangeStartDate} onChangeEndDate={handleChangeEndDate} />}
    ></LkpChart>
  );
};
export { LkpChartSDIFailuresAnalysis };
